export enum SupportedLanguages {
  EN = 'en',
  DE = 'de',
  CS = 'cs',
  ES = 'es',
  NL = 'nl',
  PT = 'pt',
  FR = 'fr',
}

export const fallbackLng = SupportedLanguages.EN;
export const languages = [
  SupportedLanguages.EN,
  SupportedLanguages.DE,
  SupportedLanguages.CS,
  SupportedLanguages.ES,
  SupportedLanguages.NL,
  SupportedLanguages.PT,
  SupportedLanguages.FR,
];

export const languageFallbacks = {
  'de-*': SupportedLanguages.DE,
  'en-*': SupportedLanguages.EN,
  'pt-*': SupportedLanguages.PT,
  'cs-*': SupportedLanguages.CS,
  'nl-*': SupportedLanguages.NL,
  'es-*': SupportedLanguages.ES,
  'fr-*': SupportedLanguages.FR,
};

export const defaultNS = 'translation';
export const i18nCookieName = 'NEXT_LOCALE';
/**
 * App-owned memo cookie for the space-derived Editor UI locale. Distinct from NEXT_LOCALE
 * (which only ever holds an explicit user pick). It caches the value getRequestConfig
 * derives from the space's working language so same-session navigations skip the lookup.
 */
export const uiLocaleMemoCookieName = 'hfm_ui_locale';
